import React, { Component } from "react";
import Modal from "react-responsive-modal";
import styles from "./index.module.scss";

class Index extends Component {
  state = {
    numPages: null,
    pageNumber: 1
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    const {
      open,
      selectedItem = {},
      handleClose,
      ambulance,
      style
    } = this.props;
    const attachments =
      selectedItem.attachment && selectedItem.attachment.split("|");
    return (
      <div>
        <Modal open={open} onClose={handleClose} styles={style}>
          {attachments ? (
            attachments.map(item => {
            return <div key={item} style={{ padding: 28 }}>
            <iframe title="报告" id="iframe123" frameBorder="0" className={styles.iframe} height="700" src={ambulance + item}></iframe>
            </div> ;
          })
          ) : <div style={{ padding: 28 }}>无相关数据</div>}
        </Modal>
      </div>
    );
  }
}

export default Index;
